import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded px-1.5 py-0.5 text-[11px] font-medium leading-tight",
  {
    variants: {
      variant: {
        default: "bg-brand/10 text-brand-deep",
        outline: "border border-line text-ink-muted",
        success: "bg-success/10 text-success",
        warn: "bg-warn/15 text-amber-700",
        danger: "bg-danger/10 text-danger",
        accent: "bg-accent-purple/10 text-accent-purple",
        muted: "bg-surface-panel2 text-ink-muted",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
